import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  svgContainer: {
    marginTop: 12,
    width: 56,
    height: 56,
  },
});
